// components/MouseFollower.jsx
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTheme } from "../contexts/ThemeContext";

const MouseFollower = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const { isDark, setIsDark } = useTheme();

  return (
    <motion.div
      className="fixed w-8 h-8 pointer-events-none z-50"
      animate={{
        x: mousePos.x - 12,
        y: mousePos.y - 12,
      }}
      transition={{ type: "spring", stiffness: 500, damping: 28 }}
    >
      <div className={`w-full h-full ${
              isDark ? "bg-white" : "bg-black"
            }  rounded-full opacity-80`} />
    </motion.div>
  );
};

export default MouseFollower;